<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    hide-submit-btn
    width="80%"
  >
    <ir-invoices-list
      :items="items"
      :page-size="items.length"
    />
  </vbt-dialog>
</template>

<script>
import { IrInvoicesList } from '@modules/costs/invoices';

export default {
  name: 'IrInvoicesViewer',

  components: {
    IrInvoicesList,
  },

  data() {
    return {
      items: [],
      orderId: '',
      dialog: false,
    };
  },

  computed: {
    title() {
      return `Invoices for order ${this.orderId}`;
    },
  },

  methods: {
    $_openDialog(items, orderId) {
      this.$set(this, 'items', items);
      this.orderId = orderId;
      this.dialog = true;
    },
  },
};
</script>
